export default "__VITE_ASSET__BaLnDnCM__"